module.exports = __webpack_public_path__ + "static/img/jianting.ea865ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/jianting.png
// module id = Sh5a
// module chunks = 24